<template>
  <section class="confirmation-wrapper">
    <h1>{{ $t('pages.confirmation.title') }}</h1>
    <div
      class="message"
      v-html="$t('pages.confirmation.message')"
    />
    <div
      class="info"
    >
      <img :src="VEHICLE.images.high">
      <div class="vehicle">
        {{ $t('pages.confirmation.your_vehicle') }} {{ VEHICLE.label }}
      </div>
      <div class="from-to">
        {{ FROM_TO_DATE }}
      </div>
      <div class="business-name">
        {{ BUSINESS.label }}
      </div>
      <div class="address">
        {{ BUSINESS.address }}
        <br>
        {{ BUSINESS.postal_code }}
        {{ BUSINESS.city && BUSINESS.city.label }}
      </div>
      <rent-button
        is-anchor
        href="/"
      >
        {{ $t('pages.confirmation.return') }}
      </rent-button>
    </div>
  </section>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import RentButton from '../../shared/RentButton'

export default {
  name: 'PaymentSuccess',
  components: {
    RentButton,
  },
  created() {
    const { lead } = window.renaultRent

    this.VEHICLE = lead.vehicle

    this.FROM_TO_DATE = `Du ${lead.date_start} à ${lead.hour_start} au ${lead.date_end} à ${lead.hour_end}`

    this.BUSINESS = lead.business
  },
  mounted() {
    if (!this.VEHICLE || !this.BUSINESS) {
      window.location = '/'
      return
    }
    this.clearCompletedInfo()
    this['stepping/SET_CURRENT_STEP'](5)
  },
  methods: {
    ...mapMutations([
      'stepping/SET_CURRENT_STEP',
    ]),
    ...mapActions({
      clearCompletedInfo: 'leads/CLEAR_COMPLETED_BOOKING_INFO',
    }),
  },
}
</script>
<style lang="scss" scoped>

section {
  color: black;
  margin: 0 auto 50px;
  max-width: 700px;

  @include font-size(16px);
}

h1 {
  color: $black;
  font-family: $f-graphie-book;
  margin: 20px auto;

  @include font-size(28px);
}

section ::v-deep a {
  color: black;
  text-decoration: underline;
}

img {
  margin: 50px auto;
}

.info {
  @include font-size(13px);
}

.vehicle,
.from-to,
.address {
  margin: 0 auto 20px;
}
</style>
